<template>
  <header>
    <nav class="navbar container navbar-expand-sm">
      <router-link class="navbar-brand" :to="{ name: `AtomsLocal`, params: { hash: '*' } }">
        <img src="@/assets/logo.svg" alt />
      </router-link>

      <div class="collapse navbar-collapse" id="navbar1">
        <ul class="navbar-nav mr-auto">
          <router-link class="nav-item" tag="li" :to="{ name: 'SingleScope', params: { id: '*' } }">
            <a class="nav-link">Assets</a>
          </router-link>
          <router-link class="nav-item" tag="li" :to="{ name: 'Events' }">
            <a class="nav-link">Events</a>
          </router-link>
          <router-link class="nav-item" tag="li" :to="{ name: 'Nodes' }">
            <a class="nav-link">Nodes</a>
          </router-link>

          <router-link class="nav-item" tag="li" :to="{ name: 'AtomsLocal' }">
            <a class="nav-link">Atoms</a>
          </router-link>
          <router-link class="nav-item" tag="li" :to="{ name: 'Templates' }">
            <a class="nav-link">Templates</a>
          </router-link>
          <router-link class="nav-item" tag="li" :to="{ name: 'Vulnerabilities' }">
            <a class="nav-link">Vulnerabilities</a>
          </router-link>

          <router-link class="nav-item" tag="li" :to="{ name: 'Sched' }">
            <a class="nav-link">Sched</a>
          </router-link>
          <router-link class="nav-item" tag="li" :to="{ name: 'Tasks' }">
            <a class="nav-link">Tasks</a>
          </router-link>
          <router-link class="nav-item" tag="li" :to="{ name: 'StorageFiles' }">
            <a class="nav-link">Storage</a>
          </router-link>
          <!-- <router-link class="nav-item" tag="li" :to="{ name: 'Triggers' }">
            <a class="nav-link">Triggers</a>
          </router-link> -->

          <router-link class="nav-item" tag="li" :to="{ name: 'LuaEngine' }">
            <a class="nav-link">Lua dev</a>
          </router-link>
          <router-link class="nav-item" tag="li" :to="{ name: 'WebEngineView' }">
            <a class="nav-link">Web inspector</a>
          </router-link>
          <router-link class="nav-item" tag="li" :to="{ name: 'Logs' }">
            <a class="nav-link">Logs</a>
          </router-link>
        </ul>
        <div class="nav-item ml-left">
          <router-link :to="{ name: 'Settings' }">
            <a class="btn btn-sm btn-icon">
              <i class="vik vik-settings"></i>
            </a>
          </router-link>
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
import Mixin from "@/mixins.js";
export default {
  mixins: [Mixin],
  data() {
    return {};
  },
  mounted() {
    // console.log("hack",this.$store.getters.hackerMode)
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Header.vue